import { Card, CardBody, Col } from "reactstrap";
import { PopoverOffsetTitle } from "../../../../constants";
import { PopoverOffsetSubTitle } from "../../../../data/uiKits/Popover";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";
import OffsetLeft from "./OffsetLeft";
import OffsetRight from "./OffsetRight";

const PopoverOffset = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={PopoverOffsetTitle} span={PopoverOffsetSubTitle} />
        <CardBody className="common-flex">
          <OffsetRight />
          <OffsetLeft />
        </CardBody>
      </Card>
    </Col>
  );
};
export default PopoverOffset;
